@property --chat-thread-size-scale {
  syntax: '<number>';
  inherits: false;
  initial-value: 0;
}

.chat-thread {
  display: grid;
  grid-template: 'viewport sidebar' 100% / 1fr auto;
  width: 100%;
  height: 100%;
  container-type: size;
}

.viewport {
  grid-area: viewport;
  anchor-name: --viewport;
  display: flex;
  flex-flow: column nowrap;
  overflow: hidden auto;
  overscroll-behavior: none;
  scroll-behavior: smooth;
  container-type: size;
}

.viewport-messages {
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  anchor-name: --viewport-messages;
  anchor-scope: all;
}

.viewport-footer {
  position: sticky;
  bottom: 0;
  display: grid;
  grid-template-columns: [composer] 1fr [actions] auto;
  align-items: center;
  margin-top: auto;
  box-shadow: inset 0 1px 0 0 var(--mantine-color-dark-4);
  background: alpha(var(--mantine-color-dark-7), 0.4);
  backdrop-filter: blur(var(--mantine-spacing-sm));
  anchor-name: --viewport-footer;
  padding: var(--mantine-spacing-sm);
  gap: var(--mantine-spacing-sm);
  flex: 0 1 auto;
}

.scroll-to-bottom {
  position: absolute;
  top: calc(var(--mantine-spacing-xs) * -1);
  left: 50%;
  opacity: 1;
  translate: -50% -100%;
  transition: opacity 0.2s ease-out;
  &:not(:has(:global(.mantine-active))) {
    pointer-events: none;
    opacity: 0;
  }
}

.message-parts {
  display: flex;
  flex-flow: column nowrap;
  row-gap: var(--mantine-spacing-xs);
  > :not(:has(> :not(:empty))) {
    display: none;
  }
}

/* CHAT MESSAGES */
.message-container {
  --transition-offset: var(--mantine-spacing-xl);
  /* scroll-snap-align: start; */
  anchor-name: --message-container;
  anchor-scope: all;
  padding: var(--mantine-spacing-md);
  border-radius: inherit;
  transform-origin: var(--bezel-origin, 50% 50%);
  &:not(:nth-last-child(1 of &)) {
    padding-block-end: 0;
  }

  &[data-role='assistant'] {
    --bezel-origin: bottom left;
    --transform-multiplier: 1;
  }

  &[data-role='user'] {
    --bezel-origin: bottom right;
    --transform-multiplier: -1;
    .content-wrapper {
      display: grid;
      grid-template: 'user-action-bar content' '. branch-picker' / minmax(72px, 1fr) auto;
      justify-items: end;

      .user-action-bar {
        grid-area: user-action-bar;
        align-self: center;
        justify-self: end;
        margin-right: var(--mantine-spacing-sm);
      }

      .branch-picker {
        grid-area: branch-picker;
      }

      & > div:first-child {
        grid-area: content;
      }
    }
  }
}

.timestamp {
  align-self: flex-end;
  font-size: var(--mantine-font-size-xs);
  opacity: 0.7;
}

.assistant-footer {
  position-anchor: --message-container;
  position: absolute;
  top: calc(anchor(bottom) - 1px);
  padding-block-start: var(--mantine-spacing-xs);
  padding-inline: var(--mantine-spacing-xs);
  display: flex;
  gap: var(--mantine-spacing-sm);
  z-index: 10;
  .message-container:last-child & {
    position: relative;
  }
}

.edit-form {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-xs);
  width: 40cqw;
}

.edit-actions {
  display: flex;
  gap: var(--mantine-spacing-sm);
  justify-content: flex-end;
}

.edit-composer {
  padding: var(--mantine-spacing-xs);
  resize: none;
  background: transparent;
  border: 1px solid var(--mantine-color-dark-4);
  border-radius: var(--mantine-radius-xs);
  &:focus {
    outline: none;
    box-shadow: 0 0 0 4px alpha(var(--mantine-color-dark-4), 0.3);
  }
}

@container (width >= 60rem) {
  .thread-list {
    inline-size: 30cqi;
    max-inline-size: calc(var(--chat-thread-size-scale) * 24rem);
    border-inline-start: 1px solid var(--mantine-color-dark-4);
  }
}

@container (width < 60rem) {
  .chat-thread {
    grid-template: 'viewport' 1fr 'sidebar' auto / 100%;
  }
  .thread-list {
    block-size: 30cqb;
    max-block-size: calc(var(--chat-thread-size-scale) * 24rem);
    border-block-start: 1px solid var(--mantine-color-dark-4);
  }
}
